"use client";

import { ArrowLeft, Brain } from "lucide-react";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import { RoleTransferModel } from "@/components/tools/leadership/RoleTransferModel";
import { useLanguage } from "@/context/LanguageContext";

export default function ModelPage() {
    const { t } = useLanguage();

    return (
        <div className="min-h-screen">
            <SEO
                title={t("seo.leadership.model.title")}
                description={t("seo.leadership.model.description")}
                keywords={t("seo.leadership.model.keywords").split(",").map(k => k.trim())}
            />
            <main id="main-content" className="container mx-auto px-4 py-12">
                <Link to="/tools/leadership_roles">
                    <Button variant="ghost" className="mb-8">
                        <ArrowLeft className="mr-2 h-4 w-4" />
                        Back to Leadership Roles
                    </Button>
                </Link>

                <div className="max-w-4xl mx-auto">
                    <div className="flex items-center gap-4 mb-8">
                        <div className="p-3 bg-primary/10 rounded-xl">
                            <Brain className="h-8 w-8 text-primary" />
                        </div>
                        <h1 className="text-4xl font-bold">The Model Behind It</h1>
                    </div>

                    <div className="bg-card border rounded-xl p-8 shadow-sm">
                        <RoleTransferModel />
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
}
